export const CHAT_GPT_BLUE = '#10a37f';
export const CHAT_GPT_DARK = '#202123';
export const CHAT_GPT_LIGHT_DARK = '#343541';
export const CHAT_GPT_AI_BG = '#444654';
export const MOBILE_BG = '#ffffff';

export const VIDEO_PROCESSING_STEPS = [
  'Uploading video...',
  'Extracting video frames...',
  'Analyzing video...',
  'Transcribing video audio...',
  'Generating video summary...',
];

export const RECENT_FILES = [
  { name: 'Project_Design.png', url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=200' },
  { name: 'User_Profile.jpg', url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200' },
  { name: 'Analytics_Report.pdf', url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=200' },
];
